export const useArithmeticEvaluator = () => {

    const evaluateExpression = (value: string) => {
        if (!value || value === '') return

        let result
        try {
            const safeExpression = value.replace(/[^-()\d/*+.]/g, '')
            result = new Function(`return ${safeExpression}`)()
        } catch (error) {
            result = undefined
        }

        return result
    }

    return {
        evaluateExpression
    }
}